import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import InvoiceDetail from './pages/InvoiceDetail';
import ProformaInvoicesSection from './sections/ProformaInvoicesSection';

type Props = {}

const ProformaInvoices = (props: Props) => {
  const { t } = useTranslation("shared\\moduleNames");
  const match = useRouteMatch();
  
  return (
    <Switch>
      <Route path={`${match.path}/:invoiceId`}>
        <InvoiceDetail
          type="Proformainvoice"
          backPage={{ text: t("proformaInvoices.title"), to: match.path }}
        />
      </Route>
      <Route path={match.path}>
        <Header title={t("proformaInvoices.title")} includeBreadcrumbs />
        <ModuleContent>
          <ProformaInvoicesSection />
        </ModuleContent>
      </Route>
    </Switch>
  )
}

export default ProformaInvoices;